export const GET_BOARDING_GROUPS = 'GET_BOARDING_GROUPS';
export const CLEAR_BOARDING_GROUPS = 'CLEAR_BOARDING_GROUPS';
export const FLAG_BOARDING_GROUPS = 'FLAG_BOARDING_GROUPS';

export const FLAG_BOARDING_GROUP_ACTIVITY = 'FLAG_BOARDING_GROUP_ACTIVITY';
export const GET_BOARDING_GROUP = 'GET_BOARDING_GROUP';
export const CLEAR_BOARDING_GROUP = 'CLEAR_BOARDING_GROUP';

